import React, {useEffect, useState} from 'react';
import {useQueryClient} from "react-query";
import {Grid} from "@material-ui/core";
import {Dialog}from "../../../../controls";
import TripUldStacks from '../TripUldStacks';

const EditUldStacksDialog = (_props) => {
  const props = {
    canEdit: false,
    ..._props,
  }

  const SystemData = props.systemData;
  const classes = props.classes;

  const eventBus = SystemData.eventBus;

  const [dialogState, setDialogState] = useState({
    showDialog: false,
    record: {},
    title: 'Trip ULD Replenishment',
  });

  const queryClient = useQueryClient();

  useEffect(()=> {
    const open = async (params) => {
      const {canEdit, tripUuid, tripRoute} = params;
      setDialogState({...dialogState, showDialog:true, canEdit, tripUuid, tripRoute});
    }

    eventBus.bind("EditUldStacksDialog.open", open);

    return () => {
      eventBus.unbind("EditUldStacksDialog.open", open);
    }
  }, [dialogState, eventBus, queryClient]);

  const handleAdd = () => {
    if (eventBus) {
      eventBus.trigger('TripUldStacks.Add');
    }
  }

  if (dialogState.showDialog) {
    return (
      <Dialog
        title={dialogState.title}
        message=""
        open={dialogState.showDialog}
        dialogOptions={{fullWidth: true, maxWidth: "lg", height: 700}}
        classes={classes}
        buttons = {{
          add: {icon: "add_circle", key: "Add", label: "Add", color: "primary"},
          close:{icon: "close", key: "Close", label: "Close", color: "primary"}
        }}
        onChange={(state) => {
          if (state.buttonPressed === "add") {
            handleAdd();
          } else {
            setDialogState({...dialogState, showDialog: false});
            if (props.afterSave) {
              props.afterSave();
            }
            if (typeof props.onClose === 'function') {props.onClose()}
          }
        }}

      >
        <Grid container checkChildren={true} spacing={3}>
          <Grid item xs={12} checkChildren={true}>
            <TripUldStacks
              canEdit={dialogState.canEdit}
              tripUuid={dialogState.tripUuid}
              tripRoute={dialogState.tripRoute}
              mode="DIALOG"
            />
          </Grid>
        </Grid>
      </Dialog>
    )
  }
  return (<></>);
}

export default EditUldStacksDialog;
